import useSWR from "swr";
import { Drawer, Box, Text } from "@mantine/core";
import { fetcher } from "../../../../services/fetcher";

const drawerStyles = {
  body: {
    flex: 1,
    padding: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  content: { display: "flex", flexDirection: "column" },
};

const resolveBrochureUrl = (brochureName) => {
  if (!brochureName) return "";
  if (/^https?:\/\//i.test(brochureName)) return brochureName;
  const baseURL = import.meta.env.MODE === "development" ? import.meta.env.VITE_API_ENDPOINT : "";
  return `${baseURL}${brochureName}`;
};

const CoverBrochureDrawer = ({ coverId, opened, onClose }) => {
  const { data, error, isLoading } = useSWR(
    coverId ? `cover-api/customize-covers/${coverId}/` : null,
    fetcher,
    { revalidateOnFocus: false, dedupingInterval: 15000 }
  );

  const resolvedUrl = resolveBrochureUrl(data?.brochure_name || data?.brochure || "");

  return (
    <Drawer
      opened={opened}
      onClose={onClose}
      position="right"
      size="50%"
      title="Brochure"
      styles={drawerStyles}
    >
      {isLoading ? (
        <Box p="md">
          <Text size="sm">Loading brochure...</Text>
        </Box>
      ) : resolvedUrl ? (
        <iframe
          title="Cover brochure"
          src={resolvedUrl}
          style={{ border: 0, width: "100%", height: "100%", maxWidth: 900, maxHeight: "100%" }}
        />
      ) : error ? (
        <Box p="md">
          <Text size="sm">Failed to load brochure.</Text>
        </Box>
      ) : (
        <Box p="md">
          <Text size="sm">No brochure available.</Text>
        </Box>
      )}
    </Drawer>
  );
};

export default CoverBrochureDrawer;
